import { render } from "./Districts.vue?vue&type=template&id=cc5de692&scoped=true"
import script from "./Districts.vue?vue&type=script&lang=js"
export * from "./Districts.vue?vue&type=script&lang=js"

import "./Districts.vue?vue&type=style&index=0&id=cc5de692&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc5de692"]])

export default __exports__